export default __webpack_public_path__ + "static/media/pictogramBeaconDebtConsolidation40.07bfe9ae.svg";